<div class="container">
    <app-stepper>
        <cdk-step *ngFor="let step of educationalSteps, index as i">
            <a [ngClass]="{'inactive-link': step.enabled}" class="step step-link" [routerLink]="['step', step.id]">
                <span class="step-title" [ngClass]="{'step-title-paracelsus': isParacelsus}">
                    <ng-container *ngIf="step && step.icon && step.icon.content && step.icon.content.fileId">
                        <img
                        class="icon primary-icon primary-icon-paracelsus"
                        [src]="icons[i] | async"
                        *ngIf="icons[i] | async"
                        />
                    </ng-container>
                    <div class="title-container-paracelsus">
                        <div>
                            <h2 [ngClass]="{'inactive-text': step.enabled,
                            'locked-text': !step.progress && (step.showLock || step.parent?.showLock),
                            }">{{step?.name}}</h2>
                        </div>
                    </div>
                </span>
            </a>
            <span class="step-content">
                <span class="icon icon-paracelsus"></span>
                <ng-container *ngIf="isDopo; else navigationCard">
                    <app-navigation-card-dopo class="navigation-card" [step]="step"></app-navigation-card-dopo>
                </ng-container>
                <ng-template #navigationCard>
                    <app-navigation-card class="navigation-card" [step]="step"></app-navigation-card>
                </ng-template>
            </span>
        </cdk-step>
    </app-stepper>
</div>
